import { render, staticRenderFns } from "./TkTripadvisorRating.vue?vue&type=template&id=303cc615&"
import script from "./TkTripadvisorRating.vue?vue&type=script&lang=js&"
export * from "./TkTripadvisorRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports